import { EMPTY } from "@/constants/index";
import { format, isValid } from "date-fns";
import { DateTimeUtils } from "@/utils/DateTimeUtils";

type IProps = {
  value?: number | string | Date | null | undefined;
  time?: boolean | string;
};

export const FormattedDate = ({ value, time }: IProps) => {
  if (!value) {
    return EMPTY;
  }

  const parsedDate =
    typeof value === "string"
      ? DateTimeUtils.parseISODateOnly(value)
      : value instanceof Date
        ? value
        : new Date(value);

  if (!isValid(parsedDate)) {
    return EMPTY;
  }

  const formattedDate = format(parsedDate, "MMMM d, yyyy");

  if (time && typeof value === "string") {
    const localDate = new Date(value);

    if (isValid(localDate)) {
      const hours = String(localDate.getHours()).padStart(2, "0");
      const minutes = String(localDate.getMinutes()).padStart(2, "0");
      const seconds = String(localDate.getSeconds()).padStart(2, "0");

      const timeFormat = typeof time === "string" ? time : "HH:mm:ss";
      const formattedTime = timeFormat
        .replace("HH", hours)
        .replace("mm", minutes)
        .replace("ss", seconds);

      return `${formattedDate}, ${formattedTime}`;
    }
  }

  return formattedDate;
};
